import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { bool, func, string, object } from 'prop-types';

import Dropdown from 'apps/journey/components/dropdown';
import { resolve } from 'library/helpers/path-resolver';
import withProfileFieldData from 'apps/journey/hoc/with-profile-field-data';
import LoadGraphData from 'util/hoc/with-data';
import Query from 'library/util/query';

const StyledContainer = styled.div`
  margin-bottom: 1em;
`;

class ProfileRaceSelect extends PureComponent {
  static propTypes = {
    label: string,
    onChange: func,
    value: bool,
    name: string,
    loadFromContext: bool,
    question: object,
    required: bool,
    graph_data: object
  }

  constructor(props) {
    super(props);
  }

  state = {
    selection: '',
    loading: false
  }

  handleOnChange = ({ target }) => {
    const { value, key } = target;
    this.setState({ loading: true });
    try {
      this.props.onChange({target: {id: resolve(this.props.question, 'id', null), answer:value }});
      this.setState(() => ({
        value: key,
        loading: false
      }));
    } catch (err) {
      console.error(err);
      this.setState({
        loading: false
      });
    }
  };

  render () {
    let choices = resolve(this.props.graph_data, 'races/results', []);

    const tvalue = this.state.value || (resolve(this.props.question, 'user_response/string_response', false)) || '';
    return (
      <StyledContainer>
        <Dropdown
          onChange={this.handleOnChange}
          label={this.props.label}
          name={this.props.name}
          value={tvalue}
          required={this.props.required}
          options={choices.map((x) => {
            return {
              key: x.key_field,
              value: x.name
            };
          })}
        />
      </StyledContainer>
    );
  }
}

ProfileRaceSelect.query = async () => (
  await Query(`
      {
        races {
          results {
            id
            name
            key_field
          }
        }
      }
  `)
);

export default withProfileFieldData(LoadGraphData(ProfileRaceSelect));
